
import { Box, Button, Tooltip, Typography } from "@mui/material"
import MaterialReactTable from "material-react-table"
import React, { useCallback, useMemo, useState } from "react"
//Import Material React Table Translations
import { MRT_Localization_ES } from "material-react-table/locales/es"
//Icons Imports
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd"
import { ThemeProvider, darken } from "@mui/material"

const TablaVacaciones = ({ columnas, lineas, titulo, handleOpen, funcionEliminar, acciones = false, accionAgregar = false, accionEliminar = false, deshabilitar = false }) => {
    const [data, setData] = useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [open, setOpen] = useState(false)
    const [rowToDelete, setRowToDelete] = useState(null)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    })

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        } else {
            setData([])
        }
    }, [lineas, columnas])

    const openModal = (row) => {
        var id = row.getValue("id")
        handleOpen(id, row.original)
    }

    const openModalNew = () => {
        try {
            handleOpen()
        } catch (error) {
            console.log(error)
        }
    }

    return (
        <>
            <ThemeProvider>
                <MaterialReactTable
                    muiTablePaginationProps={{
                        rowsPerPageOptions: [5, 10],
                        showFirstLastPageButtons: false,
                    }}
                    onPaginationChange={setPagination}
                    state={{ pagination }}
                    columns={columns}
                    data={data}
                    muiTablePaperProps={{
                        sx: (theme) => ({
                            borderRadius: '0.55rem',
                            border: darken(theme.palette.background.default, 0.1),
                            bgcolor: darken(theme.palette.primary.dark, 0.1),
                            maxWidth: '100vw',
                            m: 'auto',
                        }),
                    }}
                    enableFullScreenToggle={false}
                    enableColumnFilterModes={true}
                    enableColumnOrdering={true}
                    enableColumnActions={true}
                    enableColumnFilters={true}
                    enableSorting={true}
                    enableColumnResizing
                    columnResizeMode="onChange"
                    enablePinning
                    enableRowActions={acciones}
                    enableStickyHeader
                    initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: "compact" }}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_ES}
                    defaultColumn={{
                        maxSize: 400,
                        minSize: 40,
                    }}
                    muiTableContainerProps={{ sx: { maxWidth: "95vw", fontSize: { xs: ".7rem", md: "7rem" } } }}
                    enableEditing={false}
                    renderRowActions={({ row, table }) => (
                        <Box sx={{ display: "flex", gap: "1rem" }}>
                          {
                            deshabilitar ? (
                              <Tooltip title="Para cargar vacaciones pendientes, contactate con Gestión Humana" arrow>
                                <Box>
                                  <Button size="small" variant="contained" onClick={() => openModal(row)} disabled={deshabilitar}>
                                    Solicitar
                                  </Button>
                                </Box>
                              </Tooltip>
                            ) : (
                            <Button size="small" variant="contained" onClick={() => openModal(row)}>
                              Solicitar
                            </Button>
                            )
                          }
                        </Box>
                    )}
                    renderTopToolbarCustomActions={() => (
                        <>
                            {accionAgregar ? (
                                <Button color="secondary" onClick={() => openModalNew()} variant="contained">
                                    <PlaylistAddIcon />
                                </Button>
                            ) : null}
                            <Typography variant="subtitle" p="2px">
                                {titulo}
                            </Typography>
                        </>
                    )}
                />
            </ThemeProvider>
        </>
    )
}

export default React.memo(TablaVacaciones)
